import { defineStore } from 'pinia'
// import axios from 'axios'

export const useAgencyStore = defineStore('agency', {
  state: () => ({
    id: '',
    name: '',
    logo: '',
    theme: 'default',
    mode: 'sandbox',
    currency: 'USD',
    lang: 'es',
    showProviders: false,
    currencyValues: {
     usd_brl: {
        "value": 0,
        "gap": 0,
        "factor": 0,
        "factorReceived": 0,
        "factorWithGap": 0,
        "finalValue": 0
    },
      usd_cop: {
        "value": 0,
        "gap": 0,
        "factor": 0,
        "factorReceived": 0,
        "factorWithGap": 0,
        "finalValue": 0
      },
      usd_eur: {
        "value": 0,
        "gap": 0,
        "factor": 0,
        "factorReceived": 0,
        "factorWithGap": 0,
        "finalValue": 0
      },
    }
  }),

  actions: {
    updateAgency(payload) {
      this.id = payload._id || ''
      this.name = payload.name || ''
      this.logo = payload.logo || ''
      this.theme = payload.theme || 'default'
      this.mode = payload.mode || 'sandbox'
      this.currency = payload.currency || 'USD'
      this.lang = payload?.lang || 'es'
      this.showProviders = payload.showProviders || false
      }
  },
  persist: true
})
